import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { IKebabItem } from '@r1-frontend/ui-react/components/KebabMenu';
import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { EVasWidgetType } from './hooks/useDisableVasWithAnalytics';

export interface IWidgetPopupProps {
    isOpen: boolean,
    title: string,
    text?: string,
    type?: EResultPopupStatus,
    widget?: EVasWidgetType,
    content?: JSX.Element,
    serviceButton?: ReturnType<typeof BaseButton>,
    onClose: () => void,
}

export type TWidgetPopupProps = Omit<IWidgetPopupProps, 'onClose'>;

export const defaultPopupState: TWidgetPopupProps = {
    isOpen: false,
    title: '',
    text: '',
    type: EResultPopupStatus.DEFAULT,
    widget: undefined,
    content: undefined,
    serviceButton: undefined,
};

export interface IAdvantageProps {
    id: number,
    symbolId: string,
    text: string,
}

export const watchControlAdvantages: IAdvantageProps[] = [
    {
        id: 1,
        symbolId: 'pause',
        text: 'Ставьте прямой эфир на паузу',
    },
    {
        id: 2,
        symbolId: 'rewind',
        text: 'Перематывайте рекламу',
    },
    {
        id: 3,
        symbolId: 'repeat',
        text: 'Смотрите архив программ за неделю',
    },
];

export enum EWidgetKebabActionType {
    ACTIVATE = 'activate',
    DETAIL = 'detail',
    DISABLE = 'disable',
    INSTRUCTION = 'instruction',
    MOVIX = 'movix',
}

export const antivirusKebabItems: IKebabItem[] = [
    {
        value: EWidgetKebabActionType.DETAIL,
        label: 'Подробнее',
    },
    {
        value: EWidgetKebabActionType.INSTRUCTION,
        label: 'Инструкция по настройке',
    },
    {
        value: EWidgetKebabActionType.DISABLE,
        label: 'Отключить',
    },
];

export const gamersKebabItems: IKebabItem[] = [
    {
        value: EWidgetKebabActionType.INSTRUCTION,
        label: 'Инструкция по настройке',
    },
    {
        value: EWidgetKebabActionType.DETAIL,
        label: 'Перейти на сайт',
    },
    {
        value: EWidgetKebabActionType.DISABLE,
        label: 'Отключить',
    },
];

export const tvPacketKebabItems: IKebabItem[] = [
    {
        value: EWidgetKebabActionType.DETAIL,
        label: 'Подробнее',
    },
    {
        value: EWidgetKebabActionType.MOVIX,
        label: 'Смотреть на Movix',
    },
    {
        value: EWidgetKebabActionType.DISABLE,
        label: 'Отключить',
    },
];

export const watchEverywhereKebabItems: IKebabItem[] = [
    {
        value: EWidgetKebabActionType.MOVIX,
        label: 'Открыть Movix',
    },
];

export const watchEverywhereInstruction = 'Войдите в личный кабинет Дом.ру с устройства, ' +
    'на котором хотите активировать эту услугу. Сделать это можно:' +
    '<ul><li>На сайте Дом.ру</li><li>На сайте Movix</li><li>В мобильном приложении Мой Дом.ру</li>' +
    '<li>В мобильном приложении Movix</li><li>В приложении Movix для телевизоров</li><li>С приставки Movix</li></ul>' +
    'Услуга автоматически заработает на устройстве, с которого вы войдёте в личный кабинет.';
